import "./../../styles/NotificationFilterBar.css";

const NotificationFilterBar = ({
    search,
    setSearch,
    audience,
    setAudience,
    status,
    setStatus,
}) => {
    return (
        <div className="notification-filter">

            <input
                type="text"
                placeholder="Search notification..."
                value={search}
                onChange={(e) =>
                    setSearch(e.target.value)
                }
            />

            <select
                value={audience}
                onChange={(e) =>
                    setAudience(e.target.value)
                }
            >
                <option value="all">All Audience</option>
                <option value="customers">Customers</option>
                <option value="providers">Providers</option>
                <option value="deliveryPartners">
                    Delivery Partners
                </option>
            </select>

            <select
                value={status}
                onChange={(e) =>
                    setStatus(e.target.value)
                }
            >
                <option value="all">All Status</option>
                <option value="draft">Draft</option>
                <option value="scheduled">
                    Scheduled
                </option>
                <option value="sent">Sent</option>
                <option value="failed">Failed</option>
            </select>

        </div>
    );
};

export default NotificationFilterBar;